import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  box: {
    paddingTop: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

function Title({ title, children, textProps }) {
  const classes = useStyles();
  return (
    <Box className={classes.box} data-testid="title-id">
      <Typography variant="h6" {...textProps}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

Title.defaultProps = {
  children: null,
};

Title.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Title;
